import ClientJobs from './ClientJobs';

export default {
  ClientJobs,
};
